//! IMPORTANT - Order of the enum values determine the display order on the UI.
export enum ALERT_TYPE {
  // TRIP_ALERT_TYPE values
  SEARCH_DELAY = 'SEARCH_DELAY',
  BRANCH_ARRIVAL_DELAY = 'BRANCH_ARRIVAL_DELAY',

  // ORDER_ALERT_TYPE values
  COLLECTION_DELAY = 'COLLECTION_DELAY',
  ROUTE_DELAY = 'ROUTE_DELAY',
  CUSTOMER_DELAY = 'CUSTOMER_DELAY',
  DELIVERY_LATE = 'DELIVERY_LATE',
  RETURN_DELAY = 'RETURN_DELAY',
  ABANDONED_AT_STORE = 'ABANDONED_AT_STORE',
  NOTE_ADDED = 'NOTE_ADDED',
  PICK_ORDER_DELAY = 'PICK_ORDER_DELAY'
}

export const ALERT_DEFINITIONS: Record<ALERT_TYPE, object> = {
  [ALERT_TYPE.DELIVERY_LATE]: {
    heading: 'Delivery Late',
    description: `Triggers if the order has not been delivered by its expected delivery time.`
  },
  [ALERT_TYPE.COLLECTION_DELAY]: {
    heading: 'Collection Delay',
    description: `Triggers if the order has not been collected by the driver within the expected time after arriving at the collection point.`
  },
  [ALERT_TYPE.ROUTE_DELAY]: {
    heading: 'Route Delay',
    description:
      'Triggers if the driver has not arrived at the customer within the expected time after starting the route.'
  },
  [ALERT_TYPE.CUSTOMER_DELAY]: {
    heading: 'Customer Delay',
    description: `Triggers if the order has not been delivered within the expected time after the driver arrives at the customer.`
  },
  [ALERT_TYPE.RETURN_DELAY]: {
    heading: 'Return Delay',
    description: `Triggers if an abandoned order has not been returned to the branch within the expected time.`
  },
  [ALERT_TYPE.NOTE_ADDED]: {
    heading: 'Note Added',
    description: 'Triggers immediately when a driver adds a note to the order.',
    action: true
  },
  [ALERT_TYPE.ABANDONED_AT_STORE]: {
    heading: 'Abandoned at Store',
    description: 'Triggers immediately when a driver abandons an order at the branch.',
    action: true
  },
  [ALERT_TYPE.SEARCH_DELAY]: {
    heading: 'Search Delay',
    description:
      'Triggers if no driver has been assigned within the expected time after the trip is created.'
  },
  [ALERT_TYPE.BRANCH_ARRIVAL_DELAY]: {
    heading: 'Branch Arrival Delay',
    description:
      'Triggers if the driver has not arrived at the store within the expected time after accepting the trip.'
  },
  [ALERT_TYPE.PICK_ORDER_DELAY]: {
    heading: 'Pick Order Delay',
    description:
      'Triggers if the driver has not picked the order within the expected time after arriving at the store.'
  }
};
